import axios from 'axios';
import Swal from 'sweetalert2';
// import { getRoundRobinBaseUrl } from './loadBalancer';

// const baseUrl = getRoundRobinBaseUrl();
let sessionExpiredHandled = false;
const api = axios.create({
  // baseURL: baseUrl,
});

// console.log('✅ Axios instance created with base URL:', baseUrl);

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    console.log('❌ Interceptor caught error. Status:', status);

    if ((status === 401 || status === 419) && !sessionExpiredHandled) {
      sessionExpiredHandled = true; // Prevent further handling
      localStorage.setItem('logout_notification', Date.now());
      localStorage.removeItem('auth_token');

      // Use SweetAlert2 toast style
      const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        icon: 'warning',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          timerProgressBar: 'custom-swal-progress',
        },
        didClose: () => {
          // window.history.pushState(null, null, '/login');

          //       window.location.href = '/login';
        },
      });

      Toast.fire({
        title: 'Another login was detected. This session will now end.',
      });
      // Delay redirect to allow toast to show fully
      setTimeout(() => {
        window.history.pushState(null, null, '/login');
        window.location.href = '/login';
      }, 3000); // match the toast duration

    }

    return Promise.reject(error);
  }
);

export default api;